import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { CouponCodeItemStatus } from "clearline-api";
import { CouponCodeDisplay } from "../validate-coupon.model";

@Component({
  selector: "app-coupon-details",
  templateUrl: "./coupon-details.component.html",
  styleUrls: ["./coupon-details.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CouponDetailsComponent {
  @Input() couponList: CouponCodeDisplay[] = [];
  @Input() isRedeemed = false;
  @Input() selectedCoupon: CouponCodeDisplay = null;

  @Output() couponChange = new EventEmitter<CouponCodeDisplay>();

  onSelectCoupon(coupon: CouponCodeDisplay): void {
    if (!this.isRedeemed && coupon.status === CouponCodeItemStatus.Issued) {
      this.couponChange.emit(coupon);
    }
  }
}
